export const projectDetails = {
  edoctorscript:
    "<b style='color:green'>Description:</b><br/> Doctors can write prescription with a few clicks by our user friendly UI, mail the patient or print them. <br/>Provides every important aspects related to patient and prescription in one place. <br/>Stores patient records with treatment and consists huge medicine database. <br/><br/><b  style='color:green'>My Contribution:</b><br/> I worked in this project as a part time front end developer in Reactjs - Redux under the team 71bits, a startup company. <br/> I am currently working in the patient android app of this project with React-Native. I am working with them as a part time developer for more than a year",
  talibeIlm:
    "<b style='color:green'>Description:</b><br/> Talibe-Ilm is a web based generalised Madrasa / School management application. <br/>The main features are keeping tracks of expense revenue and other financial records, efficient Student management and performance tracking, handling course curriculam and employee management, results & notice publishing etc<br/><br/><b  style='color:green'>My Contribution:</b><br/> I worked in this project as a front end developer in Reactjs - Redux with a three man team led by <a href='https://www.linkedin.com/in/hasan-cse/' target='_blank'>Hasanul Islam</a>. The back end was handled by <a href='https://www.linkedin.com/in/adilreza043/' target='_blank'>Adil Reza</a> and I handled the whole front end. <br/>",
  dailyshobji:
    "<b style='color:green'>Description:</b><br/> Daily-Shobji is an e-commerce solution for fresh vegetables, an upcoming startup by <a href='https://aamartaka.com' target='_blank'>Aamartaka.com<a/> team. <br/>Buy Daily Vegetables as a package with proper nutrition plan for family or sick people who needs to follow strict nutrition plan. <br/> Create your own custom package with different vegetables. <br/>Buy vegetables in monthly plan and get discount etc.<br/> <br/><b  style='color:green'>My Contribution:</b><br/> I led the front end of this project as a full time Software Developer at <a href='https://aamartaka.com' target='_blank'>Aamartaka.com<a/>, where we used Reactjs - Redux as our main front end technology. It's a subsidiary project by the mother company Aamartaka.com<br/>",
  varsityvoice:
    "<b style='color:green'>Description:</b><br/> Online News portal mainly focused on University news. <br/>Covers daily news of public/private institutions in Bangladesh, national and international news, career and scholarship news, motivational stories of students etc. <br/> Promotes Student journalism and gives a platform to gather experience for beginner journalists.<br/> <br/><b  style='color:green'>My Contribution:</b><br/> It's a client project. I developed the entire thing.<br/>",
};
export const projectImageSteps =
  process.env.NODE_ENV === "production"
    ? [
        {
          imgPath: "./epres01.png",
        },
        {
          imgPath: "./epres02.png",
        },
        {
          imgPath: "./ePres04.png",
        },
        {
          imgPath: "./epres05.png",
        },
      ]
    : [
        {
          imgPath: "/epres01.png",
        },
        {
          imgPath: "/epres02.png",
        },
        {
          imgPath: "/ePres04.png",
        },
        {
          imgPath: "/epres05.png",
        },
      ];
export const projectImageSteps2 =
  process.env.NODE_ENV === "production"
    ? [
        {
          imgPath: "./madrasa10.png",
        },
        {
          imgPath: "./madrasa06.png",
        },
        {
          imgPath: "./madrasa04.png",
        },
        {
          imgPath: "./madrasa09.png",
        },
        {
          imgPath: "./madrasa03.png",
        },
        {
          imgPath: "./madrasa02.png",
        },
      ]
    : [
        {
          imgPath: "/madrasa10.png",
        },
        {
          imgPath: "/madrasa06.png",
        },
        {
          imgPath: "/madrasa04.png",
        },
        {
          imgPath: "/madrasa09.png",
        },
        {
          imgPath: "/madrasa03.png",
        },
        {
          imgPath: "/madrasa02.png",
        },
      ];
